import { create } from 'zustand';

export type AuthStep = 'login' | 'register';

interface IPayload {
  phone: string;
  name?: string;
  date_of_birth?: string | null;
}

type AuthFlowState = {
  step: AuthStep;
  payload: IPayload;
  authMode: 'login' | 'register';

  changeStep: (step: AuthStep) => void;
  clearStore: () => void;
  setAuthMode: (mode: 'login' | 'register') => void;
  setPayload: (payload: IPayload) => void;
};

export const useAuthFlowStore = create<AuthFlowState>((set) => ({
  step: 'login',
  payload: { phone: '' },
  authMode: 'login',

  setAuthMode: (mode) => set({ authMode: mode }),
  setPayload: (payload) => set({ payload }),
  changeStep: (step) => set({ step }),
  clearStore: () => set({ step: 'login', payload: { phone: '' } }),
}));
